var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDiversifica(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 63.881,
    height: 63.881,
    viewBox: "0 0 63.881 63.881",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7ab53f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#36953e"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2333",
    "data-name": "Group 2333",
    transform: "translate(-137.959 -1075.237)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_191",
    "data-name": "Ellipse 191",
    transform: "translate(137.959 1075.237)",
    stroke: "#fff",
    strokeWidth: 3,
    fill: "url(#linear-gradient)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 31.94,
    cy: 31.94,
    r: 31.94,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.94,
    cy: 31.94,
    r: 30.44,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "business-idea",
    transform: "translate(153.516 1086.325)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2259",
    "data-name": "Group 2259",
    transform: "translate(29.514 15.781)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5087",
    "data-name": "Path 5087",
    d: "M57.45,27.2H55.4a.6.6,0,1,0,0,1.2H57.45a.569.569,0,0,0,.6-.6A.6.6,0,0,0,57.45,27.2Z",
    transform: "translate(-54.8 -27.2)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2260",
    "data-name": "Group 2260",
    transform: "translate(25.479 4.638)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5088",
    "data-name": "Path 5088",
    d: "M49.726,8.881l-1.446,1.446a.6.6,0,1,0,.843.843L50.57,9.724a.6.6,0,0,0-.843-.843Z",
    transform: "translate(-48.1 -8.7)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2261",
    "data-name": "Group 2261",
    transform: "translate(15.781 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5089",
    "data-name": "Path 5089",
    d: "M32.6,4.253a.569.569,0,0,0,.6-.6V1.6a.6.6,0,1,0-1.2,0V3.65A.569.569,0,0,0,32.6,4.253Z",
    transform: "translate(-32 -1)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2262",
    "data-name": "Group 2262",
    transform: "translate(4.638 4.638)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5090",
    "data-name": "Path 5090",
    d: "M15.126,11.17a.6.6,0,1,0,.843-.843L14.524,8.881a.6.6,0,1,0-.843.843Z",
    transform: "translate(-13.5 -8.7)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2263",
    "data-name": "Group 2263",
    transform: "translate(0 15.781)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5091",
    "data-name": "Path 5091",
    d: "M8.45,27.2H6.4a.6.6,0,1,0,0,1.2H8.45a.569.569,0,0,0,.6-.6A.6.6,0,0,0,8.45,27.2Z",
    transform: "translate(-5.8 -27.2)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2264",
    "data-name": "Group 2264",
    transform: "translate(4.638 25.479)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5092",
    "data-name": "Path 5092",
    d: "M15.126,43.481l-1.446,1.446a.6.6,0,1,0,.843.843l1.446-1.446a.6.6,0,1,0-.843-.843Z",
    transform: "translate(-13.5 -43.3)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2265",
    "data-name": "Group 2265",
    transform: "translate(25.479 25.479)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5093",
    "data-name": "Path 5093",
    d: "M49.124,43.481a.6.6,0,1,0-.843.843l1.446,1.446a.6.6,0,0,0,.843-.843Z",
    transform: "translate(-48.1 -43.3)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2266",
    "data-name": "Group 2266",
    transform: "translate(5.042 5.05)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5094",
    "data-name": "Path 5094",
    d: "M25.091,9.394a11.337,11.337,0,0,0-6.867,20,11.353,11.353,0,0,1,3.614,7.589H24.85V27.524a6.706,6.706,0,1,1,1.265.06v9.4h3.072a11.354,11.354,0,0,1,3.734-7.65c7.951-6.927,3.072-20.359-7.83-19.937Z",
    transform: "translate(-14.171 -9.384)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2267",
    "data-name": "Group 2267",
    transform: "translate(11.324 33.851)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5095",
    "data-name": "Path 5095",
    d: "M34.117,58.344h-.843V57.2H26.046v1.144H25.2a.6.6,0,0,0,0,1.2h.843v.482A1.877,1.877,0,0,0,27.913,61.9h3.494a1.877,1.877,0,0,0,1.867-1.867v-.482h.843a.6.6,0,0,0,0-1.2Z",
    transform: "translate(-24.6 -57.2)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2268",
    "data-name": "Group 2268",
    transform: "translate(10.601 10.481)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5096",
    "data-name": "Path 5096",
    d: "M34.965,24.182a5.782,5.782,0,1,0-5.782,5.782A5.784,5.784,0,0,0,34.965,24.182Zm-5.782-.6a2.263,2.263,0,0,1,2.229,2.229,2.136,2.136,0,0,1-1.626,2.108v.361a.6.6,0,1,1-1.2,0v-.361a2.2,2.2,0,0,1-1.626-2.108.6.6,0,0,1,1.2,0,1.024,1.024,0,1,0,1.024-1.024,2.223,2.223,0,0,1-2.229-2.229,2.136,2.136,0,0,1,1.626-2.108v-.361a.6.6,0,0,1,1.2,0v.361a2.2,2.2,0,0,1,1.626,2.108.6.6,0,0,1-1.2,0,1.024,1.024,0,1,0-1.024,1.024Z",
    transform: "translate(-23.4 -18.4)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiversifica);
export default __webpack_public_path__ + "static/media/diversifica.e2a6f06d29ba1a3122a3105f6f2a4319.svg";
export { ForwardRef as ReactComponent };